module.exports = __webpack_public_path__ + "img/shortcut_sign.3409be6d.jpg";